import { memo } from 'react';
import SelectableImageCard from './SelectableImageCard';

const CompactThumbnailPicker = ({
  items = [],
  selectedId = null,
  onSelect,
  getId = (item) => item?.id,
  getThumbnail = (item) => item?.thumbnail || item?.url,
  getAlt = (item) => item?.name || item?.fileName || '',
  disabled = false,
  className = '',
}) => {
  if (!items.length) {
    return null;
  }

  const extraClass = className ? ` ${className}` : '';

  return (
    <div className={`picker-surface picker-surface--grid compact-thumbnail-picker${extraClass}`}>
      <div className="picker-surface__grid compact-thumbnail-picker__grid">
        {items.map((item) => {
          const id = getId(item);
          const thumbnail = getThumbnail(item);

          if (!id || !thumbnail) {
            return null;
          }

          return (
            <SelectableImageCard
              key={id}
              src={thumbnail}
              alt={getAlt(item)}
              selected={selectedId === id}
              onClick={() => onSelect?.(id)}
              disabled={disabled}
              className="compact-thumbnail-picker__card"
              style={{ minHeight: 0 }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default memo(CompactThumbnailPicker);
